if (!customElements.get('mobile-sticky-cart')) {
  customElements.define(
    'mobile-sticky-cart',
    class MobileStickyCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.mobile-sticky-cart__button');
        this.label = this.button?.querySelector('span');
        this.spinner = this.button?.querySelector('.loading__spinner');

        this.observer = new MutationObserver(() => this.sync());
        const productInfoContainer =
          this.closest('product-info')?.querySelector('.product__info-container') || document.body;
        this.observer.observe(productInfoContainer, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
          attributeFilter: ['aria-disabled', 'class', 'disabled'],
        });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      get sourceButton() {
        return document.getElementById(this.dataset.sourceButtonId);
      }

      sync() {
        const sourceButton = this.sourceButton;
        if (!sourceButton || !this.button || !this.label) {
          this.classList.remove('is-ready');
          return;
        }

        const sourceLabel = sourceButton.querySelector('span')?.textContent.trim();
        const disabled =
          sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
        const loading = sourceButton.classList.contains('loading');

        if (sourceLabel) this.label.textContent = sourceLabel;
        this.button.disabled = disabled;
        this.button.setAttribute('aria-disabled', String(disabled));
        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
        this.classList.add('is-ready');
      }
    }
  );
}
